<style lang="scss" src="./InputPassword.scss" scoped></style>

<template>
<section class="input-container">
  <label class="label">
    {{ label }} 
    <span v-if="isRequired">*</span>
  </label>
  <div class='input-text'>
    <input :type="inputType"
      class="input"
      :class="{'input-error': inputError}"
      :placeholder='placeholder'
      :disabled='isDisabled'
      @blur='blur'
      @focus='focus'
      v-model='input'
    />

    <i class="far fa-eye-slash" v-if="inputType === 'password'" @click="changeToText"></i>
    <i class="far fa-eye" v-if="inputType === 'text'" @click="changeToPassword"></i>
  </div>
</section>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
  name: 'ProviderInputText',
  props: {
    value: [String, Number],
    label: String,
    placeholder: {
      type: String,
      default: 'Digite aqui...'
    },
    mask: undefined,
    isDisabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    validate: null
  },

  directives: { mask },

  data () {
    return {
      input: '',
      inputError: false,
      inputType: 'password'
    }
  },

  watch: {
    input (eventValue) {
      this.$emit('input', eventValue)
    },
    value () {
      this.input = this.value
    }
  },

  mounted () {
    this.input = this.value ? this.value : ''
  },

  methods: {
    blur (e) {
      this.checkValidate()
      this.$emit('blur', e)
    },
    focus (e) {
      this.$emit('blur', e)
    },

    checkValidate () {
      this.inputError = false
      if (typeof this.validate === 'function') {
        let valid = this.validate(this.input)
        if (valid !== true) {
          this.inputError = true
        }
      }
    },

    changeToText () {
      this.inputType = 'text'
    },
    changeToPassword () {
      this.inputType = 'password'
    }
  }
}
</script>
